import { render } from "./ModalModificaPrenotazione.vue?vue&type=template&id=53b78cf2&scoped=true"
import script from "./ModalModificaPrenotazione.vue?vue&type=script&lang=js"
export * from "./ModalModificaPrenotazione.vue?vue&type=script&lang=js"

import "./ModalModificaPrenotazione.vue?vue&type=style&index=0&id=53b78cf2&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b78cf2"]])

export default __exports__